import React from 'react';
import { useLocation } from 'react-router-dom';

import { FloatingTaskFab } from './floating-task-fab';
import { PUBLIC_ROUTES } from './public-routes';

import { useDesignTokens } from '~/client/hooks/use-design-tokens';
import * as GQL from '~/graphql/generated/client';
import { dashboardRouteUtil } from '~c/routes';

const PUBLIC_ROUTE_PREFIXES = Object.values(PUBLIC_ROUTES).map((route) =>
  route.split(':')[0].replace(/\/$/, '')
);

function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/')
  );
}

/**
 * Global floating action button shown on every authenticated page when the
 * current user has pending tasks to review. Clicking it navigates to the
 * tasks page. Skips the query entirely on public (unauthenticated) routes.
 */
const FloatingTaskButton: React.FC = () => {
  const tokens = useDesignTokens();
  const location = useLocation();
  const { navigateTo } = dashboardRouteUtil.useHelper();
  const shouldSkip = isPublicRoute(location.pathname);

  const { data } = GQL.useHasPendingTasksQuery({
    fetchPolicy: 'cache-and-network',
    pollInterval: shouldSkip ? 0 : 30000,
    skip: shouldSkip,
  });

  const hasPendingTasks = Boolean(data?.hasPendingTasks?.hasPendingTasks);

  if (shouldSkip || !hasPendingTasks) {
    return null;
  }

  return (
    <FloatingTaskFab tokens={tokens} onClick={() => navigateTo('TASKS')} />
  );
};

export default FloatingTaskButton;
